<label class="subHeading"
  >Credit Card Bank Name<span *ngIf="isRequired" class="star">*</span></label
>
<mat-select formControlName="cc_name">
    <mat-option *ngFor="let obj of cc_name" [value]="obj.rb_id">
        {{obj.name}}
    </mat-option>
</mat-select>
